import React from "react";
import { articles } from "assets/articles";
import Image from "components/Image";

const Financial = () => {
  // Prioritize first 5 articles at the top
  const displayArticles = [...articles.slice(0, 5), ...articles.slice(5)];

  return (
    <div className="mt-[16px] lg:mt-[60px] w-[80%] lg:w-full mx-auto relative">
      <section className="py-[100px]">
        <div className="w-[90%] lg:w-[62%] grid grid-cols-1 lg:grid-cols-3 gap-[20px] mx-auto mt-[30px] lg:mt-0">
          {displayArticles.map((article, index) => (
            <a
              key={index}
              href={article.pdf_path}
              target="_blank"
              className="group text-transparent hover:text-[rgba(0,0,0,0.79)] relative flex justify-center items-center cursor-pointer"
              download
            >
              <div className="relative group-hover:opacity-40">
                <Image src={article.preview} alt={article.name} />
              </div>
              <p className="absolute text-[18px] font-[700] uppercase text-center w-[80%]">
                {article.name}
              </p>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Financial;
